export enum Path {
  ANALYTICS_XVVS = '/info-xvvs/',
  VVS_MINER_MOLE = '/miner-mole/',
  VVS_MINER_MOLE_MY_MOLES = '/miner-mole/my-moles/',
  VVS_MINER_MOLE_MINT = '/miner-mole/mint/',
  VVS_MINER_MOLE_MINT_SUCCESS = '/miner-mole/mint/success/',
  VVS_MINER_MOLE_GALLERY = '/miner-mole/gallery/',

  VVS_GOTCHI = '/vvsgotchi',

  VVS_GOTCHI_TEAM = '/vvsgotchi/team',
  VVS_GOTCHI_MOLE_PROFILE = '/vvsgotchi/team/mole/:tokenId',
  VVS_GOTCHI_TEAM_SELECT = '/vvsgotchi/team/select',
  VVS_GOTCHI_TEAM_FAQ = '/vvsgotchi/team/faq',
  VVS_GOTCHI_TEAM_FEED = '/vvsgotchi/team/feed',
  VVS_GOTCHI_TEAM_CLEAN = '/vvsgotchi/team/clean',
  VVS_GOTCHI_TEAM_CONGRATS = '/vvsgotchi/team/congrats',

  VVS_GOTCHI_LEADERBOARD = '/vvsgotchi?leaderboard', // refer to `Search` below
  VVS_GOTCHI_LEADERBOARD_FAQ = '/vvsgotchi?leaderboard=faq', // refer to `Search` below

  VVS_GOTCHI_QUEST = '/vvsgotchi', // landing page
  VVS_GOTCHI_QUEST_FAQ = '/vvsgotchi/quests/faq',
  VVS_GOTCHI_QUEST_HISTORY = '/vvsgotchi/quests/history',
  VVS_GOTCHI_QUEST_DETAIL = '/vvsgotchi/quest/:questId',

  VVS_GOTCHI_MOLE_PERFORMANCE = '/vvsgotchi-mole-performance/:tokenId',

  TRADE_SWAP = '/swap',
  LIQUIDITY = '/liquidity',

  BOOST_CALCULATOR = '/boost-calculator',

  XVVS = '/xvvs',
  XVVS_VAULT = '/xvvs/vault',
  XVVS_VAULT_BOOST = '/xvvs/vault/boost',
  VVS_FARM = '/farms',
  VVS_FARM_HISTORY = '/farms/history',
  VVS_FARM_SIMPLE = '/farms/classic',

  IGO = '/igo',
}

export const Search = {
  VVS_GOTCHI_LEADERBOARD: ['leaderboard', ''],
  VVS_GOTCHI_LEADERBOARD_FAQ: ['leaderboard', 'faq'],
  VVS_GOTCHI_GACHAPON: ['gachapon', ''],
} as const

export const getVvsGotchiQuestDetailPath = (questId: string) => {
  return `/vvsgotchi/quest/${questId}`
}
export const getVvsGotchiMoleProfilePath = (tokenId: string) => {
  return `/vvsgotchi/team/mole/${tokenId}`
}

export const PATHS_NOT_FOUND_TO_REDIRECT_HOME = [Path.VVS_GOTCHI]
